import React, { useState, useEffect } from 'react';
import { getAssignedWorkoutForMember } from '../api';

const MemberWorkoutDashboard = ({ memberId }) => {
    const [assignedWorkouts, setAssignedWorkouts] = useState([]);
    const [activeTab, setActiveTab] = useState({});

    useEffect(() => {
        const fetchAssignedWorkouts = async () => {
            try {
                const response = await getAssignedWorkoutForMember(memberId);
                setAssignedWorkouts(response.data);
                // Initialize active tab for each workout
                const initialTabs = {};
                response.data.forEach(workout => {
                    initialTabs[workout.assignment_id] = 'Monday';
                });
                setActiveTab(initialTabs);
            } catch (error) {
                console.error('Failed to fetch assigned workouts', error);
            }
        };
        if (memberId) {
            fetchAssignedWorkouts();
        }
    }, [memberId]);

    const getExercisesByDay = (exercises) => {
        const days = { Monday: [], Tuesday: [], Wednesday: [], Thursday: [], Friday: [], Saturday: [], Sunday: [] };
        exercises.forEach(exercise => {
            if (days[exercise.day_of_week]) {
                days[exercise.day_of_week].push(exercise);
            }
        });
        return days;
    };

    return (
        <div className="container mx-auto p-4">
            <h1 className="text-2xl font-bold mb-4">My Workout Dashboard</h1>
            {assignedWorkouts.length === 0 && <p>No workout plans assigned yet.</p>}
            {assignedWorkouts.map(workout => {
                const exercisesByDay = getExercisesByDay(workout.template.exercises);
                return (
                    <div key={workout.assignment_id} className="mb-6 p-4 border rounded shadow-lg">
                        <h2 className="text-2xl font-semibold">{workout.template.template_name}</h2>
                        <p className="text-gray-700 mb-4">{workout.template.description}</p>
                        
                        <div className="border-b border-gray-200">
                            <nav className="-mb-px flex space-x-8" aria-label="Tabs">
                                {Object.keys(exercisesByDay).map(day => (
                                    exercisesByDay[day].length > 0 && (
                                        <button
                                            key={day}
                                            onClick={() => setActiveTab({...activeTab, [workout.assignment_id]: day})}
                                            className={`${activeTab[workout.assignment_id] === day ? 'border-indigo-500 text-indigo-600' : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'} whitespace-nowrap py-4 px-1 border-b-2 font-medium text-sm`}
                                        >
                                            {day}
                                        </button>
                                    )
                                ))}
                            </nav>
                        </div>

                        <div className="mt-4">
                            {Object.keys(exercisesByDay).map(day => (
                                <div key={day} style={{ display: activeTab[workout.assignment_id] === day ? 'block' : 'none' }}>
                                    {exercisesByDay[day].map(exercise => (
                                        <div key={exercise.template_exercise_id} className="p-3 mb-2 border-b grid grid-cols-5 gap-4 items-center">
                                            <p className="font-bold col-span-2">{exercise.name}</p>
                                            <p><strong>Sets:</strong> {exercise.sets}</p>
                                            <p><strong>Reps:</strong> {exercise.reps}</p>
                                            <p><strong>Weight:</strong> {exercise.weight}</p>
                                        </div>
                                    ))}
                                </div>
                            ))}
                        </div>
                    </div>
                )
            })}
        </div>
    );
};

export default MemberWorkoutDashboard;